import { getUserData } from '@moonpig/web-core-analytics'
import {
  getLastLoginLocalStorage,
  LastLoginMethod,
} from '@moonpig/web-core-auth'

export const inferLoginMethod = (email: string): LastLoginMethod => {
  const lastLoginStore = getLastLoginLocalStorage()

  if (lastLoginStore?.method) {
    return lastLoginStore.method
  }

  const gaUserData = getUserData()

  if (gaUserData?.loginMethod) {
    switch (gaUserData.loginMethod) {
      case 'google':
      case 'google one tap':
        return 'google'
      case 'apple':
        return 'apple'
      default:
        return 'email'
    }
  }

  const lowerEmail = email.toLowerCase()
  const appleDomains = ['@privaterelay.appleid.com', '@icloud.com']

  if (appleDomains.some(domain => lowerEmail.endsWith(domain))) {
    return 'apple'
  }

  return 'email'
}
